export default __webpack_public_path__ + "static/media/hexagons-no-2.6cb01f6d.mid";